module.exports = __webpack_public_path__ + "static/media/spkr_gw.915bc7db.png";